import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";

// const debug = "NotepadModule"
const debug = false

export class NotepadModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.NOTEPAD, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                    = "Notepad"
        this.description             = "Your personalized notepad for instant notes. Quickly capture ideas, tasks and important moments to stay organized and efficient within your work."
        this.svgIcon                 = "isvg-view-my-notes"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = "Productivity & Collaboration"
        this.settingsUrl             = "settings/notepad"

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}